<template>
    <RentalsListingsShell>
        <CardShell>
            <BackLinkHeading text="Upcoming Rentals" linkText="My Rentals & Listings" route="/rentals-listings-mobile"/>

            <HugeSpinner v-if="loadingUpcomingRentals"/>

            <div v-else>
                <EmptyCard 
                    v-if="!upcomingRentals"
                    class="w-75 pv5"
                    :image="require(`@/assets/img/graphic_calendar.svg`)"
                    description="There are no upcoming rentals."
                    buttonText="Search for tools & equipment"
                    route="search?q="
                />
                <RentalList v-else :imageLarge="['sm', 'lg']" :tools="upcomingRentals" />
            </div>
            
        </CardShell>
    </RentalsListingsShell>
</template>

<script>
import RentalsListingsShell from '@/components/rentalsListings/shared/RentalsListingsShell.vue';
import CardShell from '@/components/global/CardShell.vue';
import BackLinkHeading from '@/components/controls/BackLinkHeading.vue';
import EmptyCard from '@/components/global/EmptyCard.vue';
import RentalList from '@/components/global/RentalList.vue';
import { mapState } from 'vuex';
import HugeSpinner from '@/components/controls/HugeSpinner.vue';

export default {
    data() {
        return {
            resultCount: 24
        };
    },
    components: {
        RentalsListingsShell,
        CardShell,
        EmptyCard,
        BackLinkHeading,
        RentalList,
        HugeSpinner
    },
    computed: {
        ...mapState('rentals', ['upcomingRentals', 'loadingUpcomingRentals'])
    }
};
</script>
